import i18n from "@/plugins/vue-i18n";

const ProhibitedMaterials = () =>
  import(/* webpackChunkName: "rules" */ "@/views/advert/rules/ProhibitedMaterials.vue");

const rules = [
  {
    path: "/rules/prohibited-materials",
    name: "ProhibitedMaterials",
    component: ProhibitedMaterials,
    meta: {
      title: i18n.t("page.prohibitedMaterials.title"),
    },
  },
];

export default rules;
